import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

import Field from 'zignal-landscape/lib/Field';
import Input from 'zignal-landscape/lib/Input';
import Label from 'zignal-landscape/lib/Label';

const DashboardTitleInput = ({
  isSaving,
  isSubmitted,
  onChange,
  onFocused,
  onSubmit,
  shouldFocus,
  value,
  typeLabel
}) => {
  // Hack to focus the title input
  const titleInputRef = useRef(null);

  function focusTitleInput() {
    titleInputRef.current.querySelectorAll('input')[0].focus();
    onFocused();
  }

  useEffect(() => {
    if (titleInputRef.current && shouldFocus) {
      focusTitleInput();
    }
  }, [titleInputRef.current, shouldFocus]);

  function handleOnChange(event) {
    onChange && onChange(event.target.value);
  }

  function handleKeyDown(event) {
    if (event.keyCode === 13 && !isSaving) {
      onSubmit();
    }
  }

  return (
    <React.Fragment>
      <Field>
        <Label>Title</Label>
        <div ref={titleInputRef}>
          <Input
            data-cy="dashboard-settings-title"
            placeholder={`Enter a name for your ${typeLabel}`}
            error={isSubmitted && !(value.trim())}
            onChange={handleOnChange}
            onKeyDown={handleKeyDown}
            value={value}
          />
        </div>
      </Field>
    </React.Fragment>
  );
};

DashboardTitleInput.propTypes = {
  isSaving: PropTypes.bool,
  isSubmitted: PropTypes.bool,
  onChange: PropTypes.func,
  onFocused: PropTypes.func,
  onSubmit: PropTypes.func,
  shouldFocus: PropTypes.bool,
  value: PropTypes.string,
  typeLabel: PropTypes.string
};

export default DashboardTitleInput;
